import * as React from 'react';
const h = React.createElement;

export interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  extra?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  loading?: boolean;
  size?: 'small' | 'default';
  bordered?: boolean;
}

const Card: React.FC<CardProps> = function Card(props) {
  const {
    title,
    extra,
    children,
    className = '',
    loading = false,
    size = 'default',
    bordered = true,
    ...rest
  } = props;
  const paddingClass = size === 'small' ? 'p-4' : 'p-6';
  const borderClass = bordered ? 'border border-dark-700' : 'border border-transparent';

  return h(
    'div',
    {
      className: `bg-dark-800/80 rounded-xl shadow-lg ${borderClass} ${className}`,
      ...rest,
    },
    title &&
      h(
        'div',
        {
          className: `flex items-center justify-between ${paddingClass} border-b border-dark-700`,
        },
        h('div', { className: 'text-base font-semibold text-white' }, title),
        extra && h('div', {}, extra),
      ),
    h(
      'div',
      { className: title ? paddingClass : `${paddingClass} pt-5` },
      loading
        ? h(
            'div',
            { className: 'flex items-center justify-center py-8' },
            h(
              'svg',
              {
                className: 'animate-spin h-6 w-6 text-primary-500',
                fill: 'none',
                viewBox: '0 0 24 24',
              },
              h('circle', {
                className: 'opacity-25',
                cx: '12',
                cy: '12',
                r: '10',
                stroke: 'currentColor',
                strokeWidth: '4',
              }),
              h('path', {
                className: 'opacity-75',
                fill: 'currentColor',
                d: 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z',
              }),
            ),
          )
        : children,
    ),
  );
};

export { Card };
